import { Component,OnInit, Input, Output ,EventEmitter,LOCALE_ID} from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material'
import { MatSnackBar } from '@angular/material/snack-bar';

import { DialogService,InstructionService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

import * as moment from 'moment';
import { DateAdapter, MatDatepickerInputEvent , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

const KEY = 'lockform'

@Component({
  selector: 'atyl-form-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['./lock.component.scss'] ,
  	providers: [
      { provide: LOCALE_ID, useValue: 'fr-FR' },
      { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
      { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
      //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
      {
        provide: MAT_DATE_FORMATS, useValue: {
          parse: {
            dateInput: 'L',
          },
          display: {
            dateInput: 'L',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'L',
            monthYearA11yLabel: 'MMM YYYY',
          },
        }
      },
    ],
})
@Stringable({
  path: 'views/partials/content/general/lock',
  key: KEY,
})
export class FormulaireLockComponent implements OnInit {

  expanded: boolean = false;
  @Input() form: any;
  @Output() changed:EventEmitter<any> = new EventEmitter<any>();
  
 @StringableValues(KEY) strings: any

  constructor(
	public dialog: DialogService,
	private instructionService: InstructionService,
	private snackbar: MatSnackBar,
  ) { }

  ngOnInit() {
	console.log("FormulaireLockComponent init",this.form,this.strings);
  }
  
  lockForm( etat: number) {
  		//if (this.updDossier) {
  			let ask: string = (etat == 1) ? this.strings.lock_ask : this.strings.unlock_ask;
			let resultmessage: string = (etat == 1) ? this.strings.lock : this.strings.unlock;
			  			
			console.log("FormulaireLockComponent ask",etat,ask, this.strings);
			const confDialogLockRef = this.dialog.open(ConfirmComponent, {
  				data: {
  					libelle: ask,
				},
				draggable: false,
				 resizable: false,
  			});
  			confDialogLockRef.afterClosed().subscribe(res => {
  				if (res === 'true') {
  					this.instructionService.lock(this.form.ID, etat).subscribe((res:JSONRpcResponse) => {
  						console.log("FormulaireLockComponent action",res )
						
						if (res.error!=undefined) { 
							let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
							  let snackBarRef = this.snackbar.open(message,'', {
						                duration: 15000
							});
						}
						if (res.result!=undefined) { 
							
							  let snackBarRef = this.snackbar.open(resultmessage + " effectué",'', {
						          duration: 15000
							});
							this.changed.emit(res.result);
						}						
					       
						
  					});
  				}
  			});

  	//	}
  	}
	
	getTitleDeverruiller(etat:boolean=false) {
			
			let alt:string=(etat) ? this.strings.lock : this.strings.unlock;
			if (this.form.verrouilleur!=undefined && this.form.verrouilleur) {
				
				let names:string[]=[];
				if (this.form.verrouilleur.prenom!=undefined) 
					names.push(this.form.verrouilleur.prenom)
				if (this.form.verrouilleur.nom!=undefined) 
					names.push(this.form.verrouilleur.nom)
				if (this.form.date_verrouille!=undefined && this.form.date_verrouille) {
					let dtver= moment.parseZone(this.form.date_verrouille);
					if (dtver instanceof moment)
						names.push("\nle "+ dtver.format("DD/MM/YYYY HH:mm"));
			    }
				
				if 	(names.length>0)
					alt+="\n"+names.join(" ");		
			}
			return alt;	
	}
	

}